const CPF = {
  regexForMask: /(\d{3})(\d{3})(\d{3})(\d{2})/,
  mask: "$1.$2.$3-$4"
};

const CNPJ = {
  regexForMask: /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
  mask: "$1.$2.$3/$4-$5"
};

export const applyMask = (pattern: typeof CPF, value: string) => {
  return value && value.replace(pattern.regexForMask, pattern.mask);
};

export function CPForCNPJ(str: number | string) {
  str = (str || "").toString().replace(/\D/g, "");
  return applyMask(str.length > 14 ? CNPJ : CPF, str);
}
